export default __webpack_public_path__ + "static/preview-rfq-fabric-1-3b03ca555907509ffd22a44bc792aaa3.png";